
var absoluteUrlRegExp = new RegExp('^(?:[a-z]+:)?//', 'i');

export default class BaseUrl {

	/**
	 * Returns the base url, and ensures it ends with "/"
	 */
	static get(): string {
		let baseUrl: string;
		if (window.document.baseURI !== undefined) {
			baseUrl = window.document.baseURI;
		} else {
			// Need for older browsers (e.g. IE11)
			const bases = window.document.getElementsByTagName("base");
			if (bases.length > 0) {
				baseUrl = bases[bases.length - 1]!.href;
			} else {
				baseUrl = window.location.href.substring(0, window.location.href.lastIndexOf("/") + 1);
			}
		}

		baseUrl = baseUrl.charAt(baseUrl.length - 1) === "/" ? baseUrl : baseUrl + "/";
		return baseUrl;
	}


	static apply(url: string) {
		if (absoluteUrlRegExp.test(url)) {
			return url;
		}
		return BaseUrl.get() + url;
	}
}